const useServiceWorker = false && ('serviceWorker' in navigator);
export default useServiceWorker;